"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStoreApiClient = createStoreApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function mapStoreApiToStoreDto(partnerId, store) {
    return {
        partnerId,
        acceptCropProtection: store.accept_crop_protection,
        acceptFertilizerBigbag: store.accept_fertilizer_bigbag,
        acceptFertilizerBulk: store.accept_fertilizer_bulk,
        acceptFertilizerOtherPackaging: store.accept_fertilizer_other_packaging,
        acceptFertilizerTank: store.accept_fertilizer_tank,
        acceptSeeds: store.accept_seeds,
        addressLine1: store.address_line1,
        addressLine2: store.address_line2,
        addressLine3: store.address_line3,
        city: store.city,
        code: store.code,
        contactPhone: store.contact_phone,
        gpsLocationLat: store.gps_location_lat,
        gpsLocationLong: store.gps_location_long,
        isClickAndCollect: store.is_click_and_collect,
        isDeparturePoint: store.is_departure_point,
        isPickupPoint: store.is_pickup_point,
        name: store.name,
        postalCode: store.postal_code,
        region: store.region,
        schedule: store.schedule,
        state: store.state,
        timezone: store.timezone,
        industrialCapabilities: store.industrial_capabilities
    };
}
function createStoreApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function findAllStoresByPatnerId(partnerId) {
        try {
            const response = await client.get(`/v1/cooperatives/${partnerId}/stores`);
            return response.data.map(mapStoreApiToStoreDto.bind(null, partnerId));
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        findAllStoresByCooperativeId: findAllStoresByPatnerId
    };
}
